/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { ButtonGroup } from '@atlaskit/button';
import { FloatingToolbarButton as Button, FloatingToolbarSeparator } from '@atlaskit/editor-common/ui';
import { Box, xcss } from '@atlaskit/primitives';
var containerStyles = xcss({
  marginLeft: 'space.100'
});
export var LayoutGroup = function LayoutGroup(_ref) {
  var layoutButtons = _ref.layoutButtons,
    dispatchCommand = _ref.dispatchCommand,
    hide = _ref.hide;
  return jsx(Box, {
    xcss: containerStyles
  }, jsx(ButtonGroup, null, layoutButtons.map(function (item, idx) {
    switch (item.type) {
      case 'separator':
        // Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        return jsx(FloatingToolbarSeparator, {
          key: idx
        });
      case 'button':
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var ButtonIcon = item.icon;
        return jsx(Button
        // Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        , {
          key: idx,
          icon: item.icon ? jsx(ButtonIcon, {
            label: item.title
          }) : undefined,
          title: item.title,
          selected: item.selected,
          disabled: item.disabled,
          onClick: function onClick() {
            dispatchCommand(item.onClick);
            hide();
          }
        });
    }
  })));
};